// src/components/common/ConsentModal.jsx
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setConsentAccepted } from "../../store/generalSlice";
import { updateConsent } from "../../analytics";

export default function ConsentModal() {
    const dispatch = useDispatch();
    const accepted = useSelector(state => state.general.consentAccepted);

    useEffect(() => {
        // En Brasil, el modal se muestra si no ha aceptado.
        // Podríamos aplicar un default 'denied' aquí si quisiéramos,
        // pero mejor hacerlo globalmente.
    }, [accepted]);

    const handleAccept = () => {
        console.log("[DEBUG Consent Flow] User clicked 'Acessar o site' button in ConsentModal.");
        dispatch(setConsentAccepted(true));
        updateConsent(true); // GTM Consent Mode Update
    };

    if (accepted) return null;

    return (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog"
            style={{
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1050
            }}
        >
            <div className="modal-dialog modal-dialog-centered modal-lg" role="document"
                style={{
                    maxWidth: "1200px",
                    width: "90%",
                    height: "60vh", // Usa vh para altura relativa a la ventana
                    maxHeight: "80vh",
                    minHeight: "600px", // Opcional: altura mínima
                    overflowY: "auto",
                    display: "flex", // Importante para que el hijo crezca
                    // alignItems: "center",
                    // justifyContent: "center"
                }}
            >
                <div className="modal-content bg-dark text-white rounded-4 shadow-lg border-0 p-4 position-relative"
                    style={{
                        backgroundImage: "url(/assets/images/bg-modal.webp)",
                        backgroundSize: "cover",
                        height: "100%", // Toma toda la altura del padre
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center"
                    }}
                >
                    <div className="modal-body text-center "
                        style={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                    >
                        {/* <img src="/assets/images/logo-white.svg" alt="Rainbow" className="mb-4" style={{ height: 50 }} /> */}
                        <h2 className="fw-bold mb-3" style={{ color: '#b9d561' }}>ATENÇÃO</h2>
                        <p className="mb-5">
                            Você está no site da <strong>Rainbow Agro Brasil</strong>.<br />
                            O conteúdo deste site é direcionado a agricultores e outros profissionais do setor agrícola.
                        </p>
                        {/* <button onClick={handleAccept} className="btn btn-outline-light px-4">
                            Acessar o site <i className="bi bi-arrow-right ms-1" />
                        </button> */}
                        <button onClick={handleAccept}
                            to="/serviceunits"
                            className="btn btn-mod btn-large btn-round btn-solid-green btn-hover-anim"
                            style={{ backgroundColor: '#287d6b' }}
                        >
                            <span>Acessar o site <i className="bi bi-arrow-right ms-1" /></span>
                        </button>
                    </div>
                </div>
            </div>
        </div >
    );
}
